import { render } from "./AdminView.vue?vue&type=template&id=9b2d9f5a&scoped=true&ts=true"
import script from "./AdminView.vue?vue&type=script&lang=ts"
export * from "./AdminView.vue?vue&type=script&lang=ts"

import "./AdminView.vue?vue&type=style&index=0&id=9b2d9f5a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b2d9f5a"]])

export default __exports__